import React from "react";
import { Box, BoxProps } from "@chakra-ui/react";

const CardContent = (props: BoxProps) => <Box px="6" py="4" {...props} />;
export default CardContent;
